import { useEffect, useState } from "react";
import { api } from "../lib/api";
import { ContestCard } from "../components/ContestCard";
import { SectionHeader } from "../components/SectionHeader";

const FILTERS = [
  { id: "all", label: "Todos" },
  { id: "main", label: "Principais" },
  { id: "free", label: "Gratuitos" },
  { id: "closed", label: "Encerrados" },
];

export default function Contests() {
  const [items, setItems] = useState([]);
  const [filter, setFilter] = useState("all");

  useEffect(() => {
    api.get("/contests").then((r) => setItems(r.data));
  }, []);

  const shown = items.filter((c) => {
    if (filter === "main") return c.is_main && c.status === "active";
    if (filter === "free") return !c.is_main && c.status === "active";
    if (filter === "closed") return c.status === "closed";
    return true;
  });

  return (
    <div className="mx-auto max-w-7xl px-5 py-16 lg:px-8" data-testid="contests-page">
      <SectionHeader kicker="// Arena de competição" title="Concursos">
        <div className="flex flex-wrap gap-2">
          {FILTERS.map((f) => (
            <button
              key={f.id}
              data-testid={`contests-filter-${f.id}`}
              onClick={() => setFilter(f.id)}
              className={`rounded-full border px-4 py-2 font-mono-tech text-xs uppercase tracking-wider transition-colors duration-200 ${filter === f.id ? "border-lime-400 bg-lime-400 text-black" : "border-white/15 text-slate-300 hover:border-lime-400/60"}`}
            >
              {f.label}
            </button>
          ))}
        </div>
      </SectionHeader>
      <div className="grid gap-5 md:grid-cols-2 lg:grid-cols-3">
        {shown.map((c, i) => <ContestCard key={c.id} contest={c} index={i} />)}
      </div>
      {shown.length === 0 && <p className="py-20 text-center text-slate-400" data-testid="contests-empty">Nenhum concurso aqui no momento.</p>}
    </div>
  );
}
